
import React from 'react';
import DeliverableDetail from '@/components/twitter/DeliverableDetail';

const DeliverablePage = () => {
  return (
    <div className="p-6">
      <DeliverableDetail />
    </div>
  );
};

export default DeliverablePage;
